module.exports = __webpack_public_path__ + "img/e1c7567.png";